import styled from 'styled-components'

import { TitleSection as TitleSectionBase } from '@organisms/TitleSection'
import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'

export const Link = styled(LinkBase)`
    display: block;
    text-decoration: none;
    ${(props) => props.theme.typo.bodyM}
    color: ${(props) => props.theme.color.g600};
    margin-bottom: 10px;

    &:hover {
        text-decoration: underline;
    }
`

export const Title = styled.div`
    ${(props) => props.theme.typo.bodyL}
    ${(props) => props.theme.fontWeight.medium}
    color: ${(props) => props.theme.color.g600};
    margin-bottom: 20px;
`

export const TitleSection = styled(TitleSectionBase)`
    padding-bottom: 100px;
    background-color: ${(props) => (props.mode === 'Dark' ? props.theme.color.p600 : props.theme.color.white)};

    ${(props) =>
        props.mode === 'Dark' &&
        `
        ${Link}, ${Title} {
            color: ${props.theme.color.white};
        }
    `}
`
